import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {
  formatConsentUpdatedAtDisplay,
  formatConsentVersionDisplay,
} from '@/helpers/consentMetadata';
import { termsCopy } from '@/Pages/Terms/copy';
import '@/Pages/Terms/TermsPage.sass';

type TermsHeaderProps = {
  version: string;
  updatedAt: string;
};

export function TermsHeader({
  version,
  updatedAt,
}: TermsHeaderProps): JSX.Element {
  const formattedVersion = formatConsentVersionDisplay(version);
  const formattedUpdatedAt = formatConsentUpdatedAtDisplay(updatedAt);

  return (
    <Box
      component="header"
      className="terms-header"
      data-testid="terms-header"
    >
      <Typography
        component="p"
        variant="overline"
        className="terms-header__identity"
      >
        {termsCopy.productName}
      </Typography>

      <Typography component="h1" variant="h5" className="terms-header__title">
        {termsCopy.title}
      </Typography>

      <Typography component="p" variant="body2" className="terms-header__subtitle">
        {termsCopy.subtitle}
      </Typography>

      <Box
        component="dl"
        className="terms-header__metadata"
        data-testid="terms-header-metadata"
      >
        <Box component="div" className="terms-header__metadata-item">
          <Typography component="dt" variant="caption" sx={{ display: 'none' }}>
            {termsCopy.versionLabel}
          </Typography>
          <Typography
            component="dd"
            variant="caption"
            data-testid="terms-header-version"
          >
            {formattedVersion}
          </Typography>
        </Box>
        <Box component="div" className="terms-header__metadata-item">
          <Typography component="dt" variant="caption" sx={{ display: 'none' }}>
            {termsCopy.updatedLabel}
          </Typography>
          <Typography
            component="dd"
            variant="caption"
            data-testid="terms-header-updated-at"
          >
            {formattedUpdatedAt}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
